import { Injectable } from '@angular/core';

import { indexOf, find, filter } from '@firestitch/common';

import { forEach, isArrayLikeObject } from 'lodash-es';


import { AclRole } from '@app/common/interfaces';
import { AclRoleAccesses } from '@app/common/consts';


@Injectable({
  providedIn: 'root',
})
export class AclRoleService {

  public create(data: AclRole = { id: null }) {

    data.permissions = data.permissions || {};

    if (isArrayLikeObject(data.permissions)) {
      data.permissions = {};
    }

    return data;
  }

  public getAccess(permissions, role: AclRole) {
    const result: any = [];
    role.permissions = role.permissions || {};

    const data = filter(permissions, { level: role.level });
    forEach(data, (permission) => {
      result.push(role.permissions[permission.value] ? role.permissions[permission.value] : 0);
    });

    return result.length === 1 ? result[0] : Math.max(...result);
  }

  public getInheritsCount(permissions, role: AclRole) {
    let result: number = null;

    const data = find(permissions, { level: role.level });

    if (data && data.inherits) {
      result = Object.keys(data.inherits).length;
    }

    return result;
  }

}
